// Kegtron mobile app <-> Untappd OAuth hand-off.
//
// Untappd permits ONE registered OAuth callback per organization, so the native
// app reuses this web dashboard's callback URL
// (https://dashboard.kegtron.com/untappd-callback). When Untappd redirects the
// app's in-app auth browser here, we forward the authorization code into the
// app's custom URL scheme BEFORE the SPA's auth gate runs — otherwise an
// unauthenticated in-app browser renders the callback route (or is redirected to
// login) and never returns to the app.
//
// This is why the hand-off lives here and is called at bundle load from
// index.js: that runs earlier than any React render or the componentDidMount
// auth gate, and unlike an inline <head> script it is part of the 'self' bundle
// so the enforced CSP does not block it.
//
// Discriminating web vs app: the web dashboard login sets the
// `untappd_oauth_pending` marker in localStorage before it opens its OAuth popup
// (see handleUntappdRegister in routes/settings); the native app's in-app auth
// browser has isolated storage and never sets it. Marker present => a web login
// is in progress, so leave the callback to the SPA. Marker absent => this is the
// app, forward the code into the custom scheme so openAuthSessionAsync captures
// it.
//
// NB: window.opener is NOT a reliable discriminator here — iOS
// ASWebAuthenticationSession can report a truthy window.opener, which silently
// suppressed the bounce and left the page hanging on "Processing Untappd
// authorization". The marker keys off state the web flow already owns.
//
// We only READ the marker (never remove it) so the web untappd-cb route still
// consumes it normally.
export function handleUntappdAppBounce() {
  try {
    if (window.location.pathname !== '/untappd-callback') return;
    const code = new URLSearchParams(window.location.search).get('code');
    if (!code) return;
    // Read defensively: if storage is unavailable, treat as "no marker" (app)
    // and bounce rather than hang.
    let pending = null;
    try {
      pending = window.localStorage.getItem('untappd_oauth_pending');
    } catch (e) {
      pending = null;
    }
    if (pending) return; // web login in progress — the SPA route handles it
    window.location.href =
      `kegtron://untappd-callback?code=${encodeURIComponent(code)}`;
  } catch (e) {
    // Best-effort hand-off — never block app bootstrap.
  }
}
